// control-center/src/components/credentials/GiteaBotRowDetail.tsx
import type { GiteaBotRow } from '../../lib/giteaBotCredentials';

export interface GiteaBotRowDetailProps {
  bot: GiteaBotRow;
  onMint: () => void;
}

export function GiteaBotRowDetail({ bot }: GiteaBotRowDetailProps) {
  return (
    <div style={{ padding: '0.75rem 1rem', borderTop: '1px solid #1e293b' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', fontSize: '0.8rem', color: '#94a3b8' }}>
        <div><strong style={{ color: '#64748b' }}>Bot user ID:</strong> {bot.id}</div>
        <div><strong style={{ color: '#64748b' }}>Current PAT:</strong> {bot.current_pat_name ?? 'None'}</div>
        {bot.drift_detected_at && (
          <div style={{ gridColumn: '1 / -1', background: '#451a03', color: '#fcd34d', borderRadius: 4, padding: '0.4rem 0.6rem' }}>
            <strong>Drift detected:</strong> {new Date(bot.drift_detected_at).toLocaleString()} — {bot.drift_reason}
          </div>
        )}
      </div>
    </div>
  );
}
